import { useEffect, useState } from "react";
import BackEndUrl from "./backURL";
import OLYMPIAD from "./olympiad";

/**
 * Loads this olympiad's current season from the backend: categories, dates, fees, bank
 * details, contacts and exam centers. The super admin edits these in the admin panel, so a
 * new year needs no code change or rebuild.
 */
export function useSeason() {
  const [state, setState] = useState({ season: null, error: "" });

  useEffect(() => {
    let cancelled = false;
    fetch(`${BackEndUrl.domain}/season/${OLYMPIAD.app}`, { cache: "no-store" })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((season) => !cancelled && setState({ season, error: "" }))
      .catch(() =>
        !cancelled &&
        setState({ season: null, error: "We could not load the registration form. Please check your internet connection and refresh the page." })
      );
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}

const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

/** "2026-11-14" → "14th November 2026" */
export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00`);
  return `${ordinal(d.getDate())} ${d.toLocaleDateString("en-GB", { month: "long" })} ${d.getFullYear()}`;
}

/** 4000 → "4000.00" */
export const formatFee = (fee) => Number(fee || 0).toFixed(2);
